import React from "react";
import API from "../../api/api";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import "../../styles/css/users/userTable.css";
import Switch from "@material-ui/core/Switch";
import Dialog from "@material-ui/core/Dialog";
// import Tooltip from '@material-ui/core/Tooltip';
import TableRow from "@material-ui/core/TableRow";
// import DeleteIcon from "@material-ui/icons/Delete";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { withStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import TablePagination from "@material-ui/core/TablePagination";
// import TableSortLabel from '@material-ui/core/TableSortLabel';
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import States from "../../components/States/States";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";

// const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");

// let count = 0;
let counter = 0;
function createData(
  userId,
  first_name,
  last_name,
  designation,
  name,
  userRole,
  email,
  ein,
  license_no,
  contactNo,
  status,
  address,
  state,
  zipcode
) {
  counter += 1;
  return {
    id: counter,
    userId,
    first_name,
    last_name,
    designation,
    name,
    userRole,
    email,
    ein,
    license_no,
    contactNo,
    status,
    address: { address, state, zipcode },
  };
}

function upDirection(props) {
  return <Slide direction="down" {...props} />;
}

// function desc(a, b, orderBy) {
//     if (b[orderBy] < a[orderBy]) {
//         return -1;
//     }
//     if (b[orderBy] > a[orderBy]) {
//         return 1;
//     }
//     return 0;
// }

// function getSorting(order, orderBy) {
//     return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
// }

const rows = [
  { id: "userId", numeric: false, disablePadding: false, label: "User ID" },
  {
    id: "first_name",
    numeric: false,
    disablePadding: false,
    label: "First name",
  },
  {
    id: "last_name",
    numeric: false,
    disablePadding: false,
    label: "Last name",
  },
  {
    id: "designation",
    numeric: false,
    disablePadding: false,
    label: "Designation",
  },
  { id: "name", numeric: false, disablePadding: false, label: "Company" },
  { id: "userRole", numeric: false, disablePadding: false, label: "User role" },
  { id: "email", numeric: false, disablePadding: false, label: "Email" },
  { id: "ein", numeric: false, disablePadding: false, label: "EIN" },
  {
    id: "licenseNo",
    numeric: false,
    disablePadding: false,
    label: "License number",
  },
  {
    id: "contactNo",
    numeric: false,
    disablePadding: false,
    label: "Phone number",
  },
  { id: "address", numeric: false, disablePadding: false, label: "Address" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
  { id: "actions", numeric: false, disablePadding: false, label: "Actions" },
];

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ color: "#606060", paddingRight: "30px" }}
              >
                {row.label}
                {/* <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                    </TableSortLabel>
                                </Tooltip> */}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  fixedTd: {
    paddingRight: "8px !important",
    borderBottom: "1px solid #d8d8d8",
  },
  cellWidth: {
    width: "max-content",
    maxWidth: "300px",
    wordWrap: "break-word",
  },
  cellMinWidth: {
    minWidth: "106px",
  },
  tdWidth: {
    width: "17%",
  },
});

class UsersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDelete: false,
      openEdit: false,
      editUser_data: {
        id: "",
        name: "",
        email: "",
        status: "",
        contactNo: "",
        address: "",
        zipCode: "",
        state: "",
        image_url: "",
        ein: "",
        license_no: "",
        first_name: "",
        last_name: "",
        designation: "",
        user_roles: "",
      },
      editUser_data_original: {
        id: "",
        name: "",
        email: "",
        status: "",
        contactNo: "",
        address: "",
        zipCode: "",
        state: "",
        image_url: "",
        ein: "",
        license_no: "",
        first_name: "",
        last_name: "",
        designation: "",
        user_roles: "",
      },
      order: "asc",
      orderBy: "userId",
      data: [],
      page: 0,
      rowsPerPage: 10,
      deletingUser: "",
      isDeleting: false,
      isSubmitted: false,
      isDeletingSuccess: true,

      isTableLoading: true,
    };
    this.deleteUserById = this.deleteUserById.bind(this);
  }

  componentDidMount() {
    // API.get(userRole === "Title Company Admin" ? 'user/all/3' : 'user/all/1')
    API.get(
      userRoleId === "1"
        ? "user/all/1"
        : userRoleId === "2"
        ? "user/all/3"
        : userRoleId === "4"
        ? "user/all/4"
        : ""
    )
      .then(({ data }) => {
        console.log("data", data);
        this.setState({
          data: data.response.map((user) =>
            createData(
              user.id,
              user.first_name,
              user.last_name,
              user.designation,
              user.name,
              user.user_roles[0].name,
              user.email,
              user.ein,
              user.license_no,
              user.mobile_no,
              user.status,
              user.address,
              user.state,
              user.zipcode
            )
          ),
          isTableLoading: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  async refreshUserList() {
    await API.get(
      userRoleId === "1"
        ? "user/all/1"
        : userRoleId === "2"
        ? "user/all/3"
        : userRoleId === "4"
        ? "user/all/4"
        : ""
    )
      .then(({ data }) => {
        console.log("data", data);
        this.setState({
          data: data.response.map((user) =>
            createData(
              user.id,
              user.first_name,
              user.last_name,
              user.designation,
              user.name,
              user.user_roles[0].name,
              user.email,
              user.ein,
              user.license_no,
              user.mobile_no,
              user.status,
              user.address,
              user.state,
              user.zipcode
            )
          ),
          isTableLoading: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  openDeleteModal = (userId) => {
    this.setState({
      openDelete: true,
      deletingUser: userId,
    });
  };

  closeDeleteModal = () => {
    this.setState({
      openDelete: false,
      deletingUser: "",
    });
  };

  openEditModal = (data) => {
    this.setState({
      openEdit: true,
      editUser_data: {
        ...data,
        address: data.address.address,
        state: data.address.state,
        zipCode: data.address.zipcode,
      },
      editUser_data_original: {
        ...data,
        address: data.address.address,
        state: data.address.state,
        zipCode: data.address.zipcode,
      },
    });
  };

  handleEditData(e) {
    var _editData = this.state.editUser_data;
    _editData[e.target.name] = e.target.value;
    this.setState({
      editUser_data: _editData,
    });
  }

  closeEditModal = () => {
    this.setState({
      openEdit: false,
      deletingUser: "",
    });
  };

  editUser(e) {
    e.preventDefault();
    if (
      JSON.stringify(this.state.editUser_data) !==
      JSON.stringify(this.state.editUser_data_original)
    ) {
      API.post(`user/edit_profile/${this.state.editUser_data.userId}`, {
        address: this.state.editUser_data.address,
        ein: this.state.editUser_data.ein,
        image_url: "",
        password: "",
        license_no: this.state.editUser_data.license_no,
        state: this.state.editUser_data.state,
        mobile_no: this.state.editUser_data.contactNo,
        name: this.state.editUser_data.name,
        password: "",
        password_confirmation: "",
        type: "",
        zipcode: this.state.editUser_data.zipCode,
        first_name: this.state.editUser_data.first_name,
        last_name: this.state.editUser_data.last_name,
        designation: this.state.editUser_data.designation,
        is_password_change: false,
      })
        .then(async ({ data }) => {
          console.log("data", data);
          await this.refreshUserList()
          this.setState({
            openEdit: false,
            editUser_data: {},
            editUser_data_original: {},
          });
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          alert("Something went wrong...\nPlease try again...");
        });
    }
  }

  deleteUserById() {
    var userID = this.state.deletingUser;
    API.post("user/status/" + userID, { status: 4 })
      .then((res) => {
        console.log("res", res);
        this.showCreationMessage(true);
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        this.showCreationMessage(false);
      });
  }

  showCreationMessage = (success) => {
    this.setState({
      isSubmitted: true,
      isDeletingSuccess: success ? true : false,
    });
    setTimeout(() => {
      this.setState({
        isSubmitted: false,
        isDeletingSuccess: true,
      });
      this.closeDeleteModal();
      window.location.reload();
    }, 3000);
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleUserStatus = (userId) => (event) => {
    var newStatus = event.target.checked;

    var alldata = this.state.data;
    alldata.forEach((each) => {
      if (each.userId === userId) {
        if (newStatus) {
          each.status = 1;
        } else {
          each.status = 3;
        }
      }
    });
    API.post("user/status/" + userId, { status: newStatus ? 1 : 3 })
      .then((res) => {
        console.log("res", res);
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
    this.forceUpdate();
  };

  render() {
    const { classes } = this.props;
    const {
      data,
      order,
      orderBy,
      rowsPerPage,
      page,
      isDeleting,
      isSubmitted,
      isDeletingSuccess,
      isTableLoading,
    } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <Paper className={`${classes.root} tableHeader`}>
        <div className="deleteModal">
          <Dialog
            open={this.state.openDelete}
            TransitionComponent={upDirection}
            keepMounted
            onClose={this.closeDeleteModal}
            aria-labelledby="form-dialog-delete"
            aria-describedby="form-dialog-delete-decs"
            className="deleteFormDiv"
            id="deleteFormDiv"
          >
            <div className="deleteModalHeader">
              <div className="deleteModalTitle">
                <span>Delete user</span>
              </div>
              <div className="modalClose" onClick={this.closeDeleteModal}>
                <span>&times;</span>
              </div>
            </div>
            <DialogContent className="ModalContent">
              <div className="deleteModalContent">
                {isSubmitted ? (
                  isDeletingSuccess ? (
                    <span className="userDeleteSuccess">
                      User deleted successfully!
                    </span>
                  ) : (
                    <span className="userDeleteFail">
                      User delete unsuccessful!
                    </span>
                  )
                ) : (
                  <span>Are you sure you want to delete this user?</span>
                )}
              </div>
              <div
                className="deleteModalActions"
                style={{ display: isSubmitted ? "none" : "block" }}
              >
                <button
                  className="cancelDeleteBtn"
                  onClick={this.closeDeleteModal}
                >
                  Cancel
                </button>
                <button className="deleteUserBtn" onClick={this.deleteUserById}>
                  {isDeleting ? (
                    <CircularProgress className="deleteProgress" />
                  ) : (
                    <div>Delete</div>
                  )}
                </button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <div className="deleteModal">
          <Dialog
            open={this.state.openEdit}
            TransitionComponent={upDirection}
            keepMounted
            onClose={this.closeEditModal}
            aria-labelledby="form-dialog-delete"
            aria-describedby="form-dialog-delete-decs"
            className="deleteFormDiv"
            id="deleteFormDiv"
          >
            <div className="deleteModalHeader">
              <div className="deleteModalTitle">
                <span>Edit user</span>
              </div>
              <div className="modalClose" onClick={this.closeEditModal}>
                <span>&times;</span>
              </div>
            </div>
            <DialogContent className="ModalContent">
              <div className="">
                <form onSubmit={this.editUser.bind(this)}>
                  <div className="formTwoInputs">
                    {/* First Name */}
                    <div className="formInputRow">
                      <TextField
                        id="firstname"
                        label="First name"
                        className="fullWidth"
                        fullWidth
                        margin="normal"
                        name="first_name"
                        value={this.state.editUser_data.first_name}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                    {/* Last Name */}
                    <div className="formInputRow">
                      <TextField
                        id="lastname"
                        label="Last name"
                        className="fullWidth"
                        fullWidth
                        margin="normal"
                        name="last_name"
                        value={this.state.editUser_data.last_name}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="formTwoInputs">
                    {/* Designation */}
                    <div className="formInputRow">
                      <TextField
                        id="designation"
                        label="Title"
                        className="fullWidth"
                        fullWidth
                        margin="normal"
                        name="designation"
                        value={this.state.editUser_data.designation}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                    {/* Phone */}
                    <div className="formInputRow">
                      <TextField
                        id="contactNo"
                        label="Phone number"
                        className="fullWidth"
                        type="number"
                        fullWidth
                        margin="normal"
                        name="contactNo"
                        value={this.state.editUser_data.contactNo}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="formOneInput">
                    {/* Address */}
                    <div className="formInputRowFull">
                      <TextField
                        id="address"
                        label="Company address"
                        className="fullWidth"
                        fullWidth
                        margin="normal"
                        name="address"
                        value={this.state.editUser_data.address}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="formTwoInputs">
                    {/* State */}
                    <div className="formInputRow">
                      <Select
                        value={this.state.editUser_data.state}
                        onChange={this.handleEditData.bind(this)}
                        className={`fullWidth marginBotMin selectField`}
                        id="demo-simple-select-helper"
                        inputProps={{
                          name: "state",
                          id: "selectUserState",
                        }}
                        required
                      >
                        <MenuItem value={"null"}>Select State*</MenuItem>
                        {States.map((state) => {
                          return (
                            <MenuItem key={state.name} value={state.name}>
                              {state.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                    {/* Zip Code */}
                    <div className="formInputRow">
                      <TextField
                        id="zipCode"
                        label="Zip code"
                        className="fullWidth"
                        type="number"
                        fullWidth
                        margin="normal"
                        name="zipCode"
                        value={this.state.editUser_data.zipCode}
                        onChange={this.handleEditData.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <button type="submit" className="loginBtn regBtn">
                    <div>
                      <span>Save</span>
                    </div>
                  </button>
                </form>
              </div>
            </DialogContent>
          </Dialog>
        </div>

        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
            />
            {isTableLoading ? (
              <TableBody>
                <TableRow>
                  <TableCell style={{ position: "absolute", left: "50%" }}>
                    <CircularProgress className="preloaderCircleHalf" />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {data
                  // .sort(getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((n) => {
                    return (
                      <TableRow hover tabIndex={-1} key={n.id}>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.userId}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>
                            {n.first_name}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.last_name}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>
                            {n.designation}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.name}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.userRole}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.email}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>
                            {n.ein === null ? "-" : n.ein}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>
                            {n.license_no === null ? "-" : n.license_no}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>{n.contactNo}</div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <div className={classes.cellWidth}>
                            {n.address.address}, {n.address.state},{" "}
                            {n.address.zipcode}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tdWidth}>
                          <Switch
                            checked={n.status === 1 ? true : false}
                            onClick={this.handleUserStatus(n.userId)}
                            value={"n.status"}
                            color="primary"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </TableCell>
                        <TableCell className={classes.fixedTd}>
                          <BorderColorIcon
                            // onClick={() => this.editUserById(n.userId)}
                            onClick={() => this.openEditModal(n)}
                            className="action margin-r"
                          />
                          {/* <DeleteIcon onClick={() => this.openDeleteModal(n.userId)} className="action" /> */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </div>
        <TablePagination
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

UsersTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UsersTable);



// WEBPACK FOOTER //
// ./src/pages/Users/UsersTable.js